<template>
  <section id="formsButton" class="container mx-auto border-t-2 mt-6">
    <!-- Parque Regular | Huesped -->
    <div
      id="formVisit"
      class="w-full md:w-2/5 mt-4 mx-auto px-4 md:px-0 md:min-w-124"
    >
      <div class="uppercase text-center font-bold">
        {{ $t("Forms.visit_park_hotel") }}
      </div>

      <form class="flex flex-col w-full py-4 md:px-4">
        <select
          @change="clearFormSearch()"
          v-model="GetPhotos.question"
          class="h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
        >
          <option value="" selected disabled> {{ $t("Forms.choose_option") }}</option>
          <option value="1">{{ $t("Forms.qn_visit_park") }}</option>
          <option value="2">{{ $t("Forms.qn_stay_hotel") }}</option>
          <option value="3" v-if="!dc">{{ $t("Forms.qn_code") }}</option>
        </select>

        <AddParkCode v-if="GetPhotos.question == 1"></AddParkCode>

        <AddRoom v-if="GetPhotos.question == 2"></AddRoom>

        <AddDownloadCode v-if="GetPhotos.question == 3"></AddDownloadCode>

        <!-- <p class="text-sm text-newxcaret-blue cursor-pointer">
            +Agregar otro folio
          </p> -->
      </form>
    </div>
  </section>
</template>

<script>
import moment from "moment";

import methodUser from "../mixins/methodUser";
import Multimedia from "../mixins/Multimedia";
import AddParkCode from "../forms/AddPark";
import AddRoom from "../forms/AddRoom";
import AddDownloadCode from "../forms/AddDownloadCode.vue";

export default {
  props: ["t", "dc"],
  mixins: [methodUser, Multimedia],
  components: {
    AddParkCode,
    AddRoom,
    AddDownloadCode
  },
  data: () => ({
    firstName: "",
    lastName: "",
    email: "",
    errors: [],
    downloadCodes: [],
    option: 0,
    loading: false,
    screenLoading: false,
    lastInsertItem: [],
    GetPhotos: {
      question: "",
      JoinedCode: "",
      ParkID: null,
      visitDate: "",
      tag: "",
      HotelID: null,
      Room: "",
      ArrivalDate: "",
      DepartureDate: "",
    },
    Parks: [{ value: null, text: "Seleccione una opción" }],
    Hotels: [{ value: null, text: "Seleccione una opción" }],
  }),
  computed: {
    GetParks() {
      return this.$store.getters.GetParks;
    },
    DateGood() {
      this.formatDate(this.GetPhotos.ArrivalDate);
    },
  },
  methods: {
    formatDate(date) {
      return moment(String(date)).format("YYYY-MM-DD");
    },
    validateFields() {
      this.errors = [];

      if (!this.GetPhotos.JoinedCode.trim()) {
        this.errors.JoinedCode = this.t.Validations.download_code_required;
      }

      // Verificamos si this.GetPhotos.JoinedCode cumple con 8 Character minimo
      let regex = /^.{8,}$/;
      if (!regex.exec(this.GetPhotos.JoinedCode)) {
        this.errors.JoinedCode = this.t.Validations.download_code_min;
      }

      return this.errors.length;
    },
    hasCode() {
      // Verificamos si el tag fue agregado anteriormente
      if (this.GetPhotos.question == 1) {
        return Object.values(this.$store.state.albumes).some(
          (element) =>
            element.code == this.GetPhotos.JoinedCode && element.Type == 0
        );
      }

      // Verificamos si la Reserva ya fue agregada anteriormente
      return Object.values(this.$store.state.albumes).some(
        (element) =>
          element.code == this.GetPhotos.JoinedCode && element.Type == 0
      );
    },
    async downloadCode() {
      try {
        this.msgApi.error = false;
        this.msgApi.message = "";
        this.$store.dispatch("setLoading", true);

        if (this.hasCode()) {
          this.$store.dispatch("setLoading", false);
          this.msgApi.error = true;
          this.msgApi.message = $t("Forms.exist_code");
          return;
        } else {
          let parameters1 = {
            question: this.GetPhotos.question,
          };

          // Verificamos si se envia una validacion de Agregar Parque
          if (this.GetPhotos.question == 1) {
            parameters1.push({
              ParkID: this.GetPhotos.ParkID,
              visitDate: this.GetPhotos.visitDate,
              tag: this.GetPhotos.tag,
            });
          } else {
            // Verificamos si se envia una validacion de Agregar Room
            parameters1.push({
              Room: this.GetPhotos.Room,
              ArrivalDate: this.GetPhotos.ArrivalDate,
              DepartureDate: this.GetPhotos.DepartureDate,
              HotelID: this.GetPhotos.HotelID,
            });
          }
          // Verificamos si el codigo es valido
          const response = await this.$store.dispatch(
            "isValidCode",
            parameters1
          );
          

          // Validamos si hay algun error
          if (!response.downloadCode) {
            this.$store.dispatch("setLoading", false);
            this.msgApi.error = true;
            this.msgApi.message = response.msg;
            return;
          }
          // obtenemos la informacion del album
          let parameters2 = {
            JoinedCode: this.GetPhotos.JoinedCode,
            userCodes: [],
            Type: 0,
          };
          const getAlbum = await this.$store.dispatch(
            "getAlbumes",
            parameters2
          );
          
        }

        this.$store.dispatch("setLoading", false);

        if (this.$route.name == "home") {
          this.$router.push({ name: "albumes" });
        }
      } catch (error) {
        this.msgApi.message = this.$t("Forms.try_catch_api");

        this.$store.dispatch("setLoading", false);
        this.msgApi.error = true;
      }
    },
    saveDownloadCode(data) {
      let newCodes;
      let currentCode = "";
      let recoveredData = this.getAlbumes;

      if (this.GetPhotos.question == 1) {
        currentCode = this.GetPhotos.tag;
        newCodes = {
          code: this.GetPhotos.tag,
          type: this.GetPhotos.question,
          visitDate: this.GetPhotos.visitDate,
          ParkID: this.GetPhotos.ParkID,
        };
      } else if (this.GetPhotos.question == 2) {
        currentCode = this.GetPhotos.Room;
        newCodes = {
          code: this.GetPhotos.Room,
          type: this.GetPhotos.question,
          ArrivalDate: this.GetPhotos.ArrivalDate,
          DepartureDate: this.GetPhotos.DepartureDate,
          ParkID: this.GetPhotos.HotelID,
        };
      } else {
        currentCode = this.GetPhotos.JoinedCode;
        newCodes = {
          code: this.GetPhotos.JoinedCode,
          type: this.GetPhotos.question,
        };
      }

      if (recoveredData == null || !recoveredData.length) {
        this.setCodes(newCodes);
        this.GetPhotos.JoinedCode = "";

        return false;
      } else {
        if (!this.existCode(recoveredData, currentCode)) {
          this.setCodes(newCodes);
          this.GetPhotos.JoinedCode = "";
          
          return false;
        } else {
          return true;
        }
      }
    },
    existCode(data, valueFind) {
      let exist = false;
      data.map(function (item) {
        if (item.code == valueFind) exist = true;
      });

      return exist;
    },
    onChangeQuestion(event) {},
    // Metodos para agregar los codigos a un arreglo.
    addDownloadCode() {
      this.downloadCodes.push(this.GetPhotos.JoinedCode);
      this.GetPhotos.JoinedCode = "";
    },
    clearFormSearch() {
      this.GetPhotos.JoinedCode = "";
      this.GetPhotos.ParkID = null;
      this.GetPhotos.visitDate = "";
      this.GetPhotos.tag = "";
      this.HotelID = null;
      this.Room = "";
      this.ArrivalDate = "";
      this.DepartureDate = "";
    },
  },
  created() {},
  mounted() {},
};
</script>
